
<!-- <span class="btn change-plan-btn-1" (click)="onIcon1Click()"  > 
  <span class="" ngClass="{{statusClass}}"> {{statusText}}  </span> 
</span> -->

<a  href="javascript:void(0)" (click)="onIcon1Click()" ngClass="{{statusClass}}" > {{statusText}} </a>